import moment from 'moment';
import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import {INewsFeed} from '../../types/newsFeed';
import {SubMenu} from '../SubMenu';
import {NewsPostEditorContent} from './components/NewsPostEditorContent';
import {NewsPostEditorMetaData} from './components/NewsPostEditorMetaData';

export type NewsPostEditorProps = {
  onChange: (key: string, value: any) => void;
  data: INewsFeed;
  setErrorForSubmit?: (hasError: boolean) => void;
  isCreation?: boolean;
};

export type NewsPostEditorContentProps = {
  onChange: (key: string, value: any) => void;
  data: INewsFeed;
  selectedDateToggle: boolean;
  setSelectedDateToggle: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorForSubmit?: (hasError: boolean) => void;
  isCreation?: boolean;
};

const styles: Record<string, CSSProperties> = {
  container: {
    marginTop: 16,
  },
  content: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 16,
    paddingBottom: 16,
    width: '100%',
    backgroundColor: 'white',
  },
};

export const NewsPostEditor: FunctionComponent<NewsPostEditorProps> = ({
  data,
  onChange,
  isCreation,
  setErrorForSubmit,
}) => {
  const [selectedTabs, setSelectedTabs] = useState(0);
  const [selectedDateToggle, setSelectedDateToggle] = useState<boolean>(false);
  const onChangeMenuIndex = (index: number) => setSelectedTabs(index);
  const tabs = [
    {
      label: 'Metas données',
      isRequired: true,
      ContentComponent: NewsPostEditorMetaData,
    },
    {
      label: 'Contenu news',
      isRequired: !isCreation,
      ContentComponent: NewsPostEditorContent,
    },
  ];
  const ContentComponent = tabs[selectedTabs].ContentComponent;

  useEffect(() => {
    if (
      data.publishedTimestamp &&
      !moment(data.publishedTimestamp).isSameOrBefore(moment())
    ) {
      setSelectedDateToggle(true);
    }
  }, []);

  return (
    <div style={styles.container}>
      <SubMenu
        tabs={tabs}
        selectedTabs={selectedTabs}
        onChange={onChangeMenuIndex}
      />
      <div style={styles.content}>
        <ContentComponent
          selectedDateToggle={selectedDateToggle}
          setSelectedDateToggle={setSelectedDateToggle}
          data={data}
          onChange={onChange}
          isCreation={isCreation}
          setErrorForSubmit={setErrorForSubmit}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NewsPostEditor/index.tsx